import {BaseModel} from "../base";
import {convertTimeToMoment} from "../../utils/convert_time";
import {time} from "../../services/time";

class TimeSlotModel extends BaseModel {

    constructor(data, service) {
        super(data);
        this.service = service;

        if (this.session_id)
            this.is_event = true;

        if (!this.datetime && data.time && moment.isMoment(data.date)) {
            //this.datetime = DateTimeUtilitiesService.convertTimeToMoment(data.date, data.time);//TODO !!!
            this.datetime = convertTimeToMoment(data.date, data.time);
        } else if (!moment.isMoment(this.datetime)) {
            this.datetime = moment.parseZone(this.datetime);
        }
    }

    equals(slot) {
        return slot && this.datetime.isSame(slot.datetime) && this.event_id === slot.event_id;
    }

    /**
     * @description
     * Calculates the end datetime using the provided duration or the duration from the service.
     *
     * @param {number} Optional duration
     * @returns {moment} End datetime
     */
    endDateTime(dur) {
        let duration;
        if (!dur) {
            duration = this.service.listed_durations[0];
        }
        return this.datetime.clone().add(duration, 'minutes');
    }

    /**
     * @description
     * Get availability
     *
     * @returns {number} Availability (> 0 means the slot is available)
     */
    availability() {
        return this.avail;
    }

    /**
     * @description
     * Select the time slot
     *
     * @returns {boolean} Selected status
     */
    select() {
        return this.selected = true;
    }

    /**
     * @description
     * Unselect time slot
     *
     */
    unselect() {
        if (this.selected) {
            return delete this.selected;
        }
    }

    /**
     * @description
     * Disable time slot by reason
     *
     */
    disable(reason) {
        this.disabled = true;
        return this.disabled_reason = reason;
    }

    /**
     * @description
     * Enable time slot
     *
     */
    enable() {
        if (this.disabled) {
            delete this.disabled;
        }
        if (this.disabled_reason) {
            return delete this.disabled_reason;
        }
    }

    /**
     * @description
     * Get the status of the time slot
     *
     * @returns {string} Status of the time slot
     */
    status() {
        if (this.selected) {
            return 'selected';
        }
        if (this.disabled) {
            return 'disabled';
        }
        if (this.availability() > 0) {
            return 'enabled';
        }
        return 'disabled';
    }

    static $query(params) {
        return time.query(params);
    }
}

export {
    TimeSlotModel
}
